import React from 'react'

import { Colors } from '@/common/constants'

import { Icon } from '../Icon'

interface StorageWorkerIconProps {
  className?: string
}

export const StorageWorkerIcon = React.memo(({ className }: StorageWorkerIconProps) => (
  <Icon
    size="16"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    color="currentColor"
    className={className}
  >
    <path
      d="M16.6583 5.50002C16.6583 6.09833 16.1733 6.58335 15.575 6.58335C14.9767 6.58335 14.4916 6.09833 14.4916 5.50002C14.4916 4.90171 14.9767 4.41669 15.575 4.41669C16.1733 4.41669 16.6583 4.90171 16.6583 5.50002Z"
      fill={Colors.Black[900]}
    />
    <path
      d="M19.9083 5.50002C19.9083 6.09833 19.4233 6.58335 18.825 6.58335C18.2267 6.58335 17.7416 6.09833 17.7416 5.50002C17.7416 4.90171 18.2267 4.41669 18.825 4.41669C19.4233 4.41669 19.9083 4.90171 19.9083 5.50002Z"
      fill={Colors.Black[900]}
    />
    <path d="M4 4V6H8L7.99959 4H4Z" fill={Colors.Blue[500]} />
    <path d="M4 7V9H8L7.99959 7H4Z" fill={Colors.Blue[500]} />
    <path d="M9 6V4H12.9996L13 6H9Z" fill={Colors.Blue[500]} />
    <path d="M9 7V9H13L12.9996 7H9Z" fill={Colors.Blue[500]} />
    <path
      d="M2.77369 2.79123C2.77369 2.76587 2.79459 2.7453 2.82037 2.7453H21.1796C21.2054 2.7453 21.2263 2.76587 21.2263 2.79123V12.8956C21.2263 12.921 21.2054 12.9415 21.1796 12.9415H20.5571C20.5509 13.5603 20.4204 14.1497 20.189 14.6868H21.1796C22.185 14.6868 23 13.8849 23 12.8956V2.79123C23 1.80196 22.185 1 21.1796 1H2.82037C1.81501 1 1 1.80196 1 2.79123V12.8956C1 13.8849 1.81501 14.6868 2.82037 14.6868H5.62094V18.4071H7.48799V14.6868H11.5904C11.359 14.1497 11.2285 13.5603 11.2223 12.9415H2.82037C2.79459 12.9415 2.77369 12.921 2.77369 12.8956V2.79123Z"
      fill={Colors.Black[900]}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.2556 15.7245C19.1128 15.0571 19.6628 14.0244 19.6628 12.8653C19.6628 10.8528 18.0049 9.2213 15.9596 9.2213C13.9144 9.2213 12.2564 10.8528 12.2564 12.8653C12.2564 14.0242 12.8063 15.0568 13.6633 15.7243C12.6697 16.1291 11.9257 16.7892 11.3974 17.5458C10.5592 18.7463 10.2886 20.1451 10.2886 21.0641V21.6975L10.8643 21.9808C11.6209 22.353 13.5697 23 15.9591 23C18.3485 23 20.2974 22.353 21.0539 21.9808L21.6297 21.6975V21.0641C21.6297 20.1451 21.359 18.7463 20.5208 17.5458C19.9927 16.7894 19.2489 16.1294 18.2556 15.7245ZM17.5798 12.8653C17.5798 13.7457 16.8544 14.4595 15.9596 14.4595C15.0648 14.4595 14.3395 13.7457 14.3395 12.8653C14.3395 11.9848 15.0648 11.271 15.9596 11.271C16.8544 11.271 17.5798 11.9848 17.5798 12.8653ZM15.9591 20.9503C14.4688 20.9503 13.2014 20.6516 12.4353 20.3978C12.5301 19.8664 12.7389 19.2442 13.1144 18.7064C13.6272 17.9719 14.4725 17.3517 15.9591 17.3517C17.4457 17.3517 18.291 17.9719 18.8039 18.7064C19.1793 19.2442 19.3881 19.8664 19.483 20.3978C18.7169 20.6516 17.4494 20.9503 15.9591 20.9503Z"
      fill={Colors.Black[900]}
    />
    <path
      d="M7.48799 20.2443C7.48799 20.7516 7.07004 21.1628 6.55447 21.1628C6.0389 21.1628 5.62094 20.7516 5.62094 20.2443C5.62094 19.7369 6.0389 19.3257 6.55447 19.3257C7.07004 19.3257 7.48799 19.7369 7.48799 20.2443Z"
      fill={Colors.Black[900]}
    />
  </Icon>
))
